export default "__VITE_ASSET__DxOavG9s__"